module.exports = __webpack_public_path__ + "static/media/sokol.ad4f5925.svg";